exports = module.exports = require("./../node_modules/.0.25.0@css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#app{font-family:Avenir,Helvetica,Arial,sans-serif;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;color:#2c3e50;margin-top:40px}.mint-cell{height:100px}a{color:#42b983}.head-title1{animation:myfirst 5s;animation-direction:alternate;animation-iteration-count:infinite;-moz-animation:myfirst 5s;-moz-animation-direction:alternate;-moz-animation-iteration-count:infinite;-webkit-animation:myfirst 5s;-webkit-animation-direction:alternate;-webkit-animation-iteration-count:infinite;-o-animation:myfirst 5s;-o-animation-direction:alternate;-o-animation-iteration-count:infinite}@keyframes myfirst{0%{color:#20a0ff}to{color:cyan}}@-webkit-keyframes myfirst{0%{color:#20a0ff}to{color:cyan}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/.0.25.0@css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-8991c320!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 36
// module chunks = 2